import { msg } from "../../locales/translate";
/** Add presentation hints without replacing server values or schema metadata. */
export const prepareClientSettings = <T,>(response: T): T => {
	const result = structuredClone(response);
	const sftp = (result as any)?.data?.data?.sftp;
	if (!sftp || typeof sftp !== "object" || Array.isArray(sftp)) return result;

	for (const [field, type] of Object.entries({ password: "password", passphrase: "password", privateKey: "textarea" })) {
		if (field in sftp && !sftp[`$__${field}`]?.type) sftp[`$__${field}_type`] ??= type;
	}
	if ("privateKey" in sftp && !sftp.$__privateKey?.label) sftp.$__privateKey_label ??= msg("privateKey");
	return result;
};
